/* eslint-disable no-undef */
// Helper function: Upper-case the first character of a string
const ucfirst = (str) => str.charAt(0).toUpperCase() + str.slice(1);

// Utility function: From a string-id of a ad-unit-element, generate the
// hierarchical path used by the sales dept in DFP.
// It will take a string like foo-bar-baz, and then return ['Foo',
// 'Foo_Bar', 'Foo_Bar_Baz']. It has a special-case for ids ending in
// `-[number]`, where the number won't get a level by itself, but is
// instead attached to the last level, e.g. foo-bar-1 will be ['Foo',
// 'Foo_Bar_1']..
export function adPath(id) {
  tv2.ads = tv2.ads || {};
  tv2.ads.adPathPrefix = tv2.ads.adPathPrefix || [];
  tv2.ads.adPositionPrefix = tv2.ads.adPositionPrefix || '';

  // Check if the position prefix is empty,
  // meaning the new format is not implemented, fallback to old
  let position;
  if (tv2.ads.adPositionPrefix === '') {
    position = id;
  } else {
    position = `${tv2.ads.adPositionPrefix}-${id}`;
  }

  const parts = position.replace(/-[0-9]+$/, '').split(/-/);
  const mappings = tv2.ads.adPathPrefix.slice();
  let prefix = '';
  const matches = position.match(/-([0-9]+)$/);

  if (matches) {
    parts[parts.length - 1] = `${parts[parts.length - 1]}_${matches[1]}`;
  }

  for (let i = 0; i < parts.length; i += 1) {
    mappings.push(prefix + ucfirst(parts[i]));
    prefix = `${prefix}${ucfirst(parts[i])}_`;
  }

  return mappings;
}
